var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionSummary, Typography, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useStyles from './style';
var FieldSet = function (_a) {
    var title = _a.title, defaultExpanded = _a.defaultExpanded, children = _a.children;
    var classes = useStyles();
    return (_jsxs(Accordion, __assign({ className: classes.expansionPanel, square: true, defaultExpanded: defaultExpanded, "data-testid": "panel-" + title.replace(' ', '') }, { children: [_jsx(AccordionSummary, __assign({ className: classes.titleWrapper, expandIcon: _jsx(ExpandMoreIcon, {}, void 0) }, { children: _jsx(Typography, __assign({ variant: "h4", "data-testid": "panel-title-" + title.replace(' ', '') }, { children: title }), void 0) }), void 0),
            _jsx(AccordionDetails, __assign({ className: classes.container }, { children: children }), void 0)] }), void 0));
};
export default FieldSet;
